import { Controller } from "@hotwired/stimulus"

// F4 — live 24h-window countdown. Ticks every second toward `deadline` (ISO
// string). Shows the remaining time, or a "closed" state once it elapses.
export default class extends Controller {
  static values = { deadline: String }

  connect() {
    this.render()
    this.timer = setInterval(() => this.render(), 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  render() {
    if (!this.deadlineValue) {
      this.element.textContent = "never messaged"
      this.element.dataset.state = "none"
      return
    }
    const remaining = new Date(this.deadlineValue).getTime() - Date.now()
    if (remaining <= 0) {
      this.element.textContent = "window closed"
      this.element.dataset.state = "closed"
      if (this.timer) clearInterval(this.timer)
      return
    }
    const s = Math.floor(remaining / 1000)
    const h = Math.floor(s / 3600)
    const m = Math.floor((s % 3600) / 60)
    const sec = s % 60
    const pad = (n) => String(n).padStart(2, "0")
    this.element.textContent = `${pad(h)}:${pad(m)}:${pad(sec)} left`
    this.element.dataset.state = "open"
  }
}
